import { Priority } from '../enums';
import { HexColor } from './color.model';

export interface PriorityIconStyle {
  textValue: Priority;
  color: HexColor;
}
